import React from 'react'
import Snow from './snow'

export default function Special(){
    
    return(
        <Snow />
    )
}